import urls from "../common/urls"
import { http } from "../common/post"

const PaymentSource = {
  chargeUser: (resource_token, token, no_save, tip=null) => http(urls.chargeUser, "POST", { resource_token, token, no_save, tip }),
  getSavedPaymentInfo: () => http(urls.paymentInfo, "GET"),
  getUserCharges: () => http(urls.charges, "GET"),
  signupWithPassword: (email, password) =>
    http(urls.signupWithPassword, "POST", { email, password }),
  updateProfile: (id, profile) => http(urls.profile + id, "POST", profile),
  createProfile: profile => http(urls.profile, "POST", profile),
  sendVisit: brand => http(`${urls.sendVisit}?client=${brand}`, "GET") 
}

export default PaymentSource



// WEBPACK FOOTER //
// ./assets/payment/Source.js